const exportModalCalendar = {
  exportData: 'Export Data',
  excel: 'SPREADSHEET (.XLSX)',
};

export default exportModalCalendar;
